export default class Login {
    constructor() {
        this.username = '';
        this.enabled = false;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const login = new Login();
        login.username = data.username;
        login.enabled = data.enabled;

        Object.seal(login);

        return login;
    }
}
